import * as React from "react";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ModeEdit from "@mui/icons-material/ModeEdit";
import TrashCan from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { useTheme } from "@quales/utils/theme";
import { Toolbar, Tooltip, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

interface ModalButtonBarProps {
  onSave: any;
  onEdit: any;
  onDelete?: any;
  disabled: boolean;
  height?: number;
  isCreate?: boolean;
  isDeleteButton?: boolean;
  editEnabled?: boolean;
  children?: React.ReactNode;
}

export const ModalButtonBar = (props: ModalButtonBarProps) => {
  const theme = useTheme();
  const { disabled, height, isCreate, editEnabled, isDeleteButton, onDelete } =
    props;
  const t = useTranslations();
  return (
    <Toolbar variant="dense">
      <Stack
        width={"100%"}
        height={height ? height : 30}
        spacing={2}
        alignItems={"center"}
        marginRight={4}
      >
        {editEnabled && (
          <Typography
            variant="body1"
            component="h4"
            color={theme.appColors.error}
          >
            {t("labels.editMode")}
          </Typography>
        )}
      </Stack>
      <Stack
        direction="row-reverse"
        width={"100%"}
        height={height ? height : 30}
        spacing={1}
      >
        {isDeleteButton && (
          <Tooltip title={t("labels.delete")} placement="bottom">
            <IconButton
              onClick={() => onDelete()}
              size="small"
              aria-label="edit"
              color="primary"
            >
              <TrashCan />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={t("labels.save")} placement="bottom">
          <IconButton
            onClick={() => props.onSave()}
            size="small"
            aria-label="save"
            color="primary"
            disabled={disabled}
          >
            <SaveIcon />
          </IconButton>
        </Tooltip>

        {!isCreate && (
          <Tooltip title={t("labels.edit")} placement="bottom">
            <IconButton
              onClick={() => props.onEdit()}
              size="small"
              aria-label="edit"
              color="primary"
            >
              <ModeEdit />
            </IconButton>
          </Tooltip>
        )}
        {props.children && props.children}
      </Stack>
    </Toolbar>
  );
};
export default ModalButtonBar;
